import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p411436764126773248',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
